module.exports = __webpack_public_path__ + "img/titles.0e933993.png";